export default __webpack_public_path__ + "fonts/Rubik-Regular.ttf";